
import * as THREE from 'three';
import {ikRig} from '@/ikRig.js';

class BitsConsumer{
	constructor(buf){
		this.buf = new Uint8Array(buf);
		this.offset = 0;
	}
	// bits <= 31
	consume(bits, signed=true){
		let num=0;
		for (let i = 0; i < bits; i++)
			if(this.at(this.offset++))
				num |= (1 << i);
		if(signed)
			if(num & (1<<(bits-1)))//is MSB set?
				num -= 1<<bits;
		return num;
	}
	at(b){
		const offset = b >> 3; //b/8
		const shift = b & 0b111; //b%8, 0~7
		return (this.buf[offset] & (1<<shift)) ? 1 : 0;
	}
}

export class Parser{
	static parseTable = [
		()=>{},
		Parser.parseRotationFrame,
		Parser.parseTranslationFrame,
		Parser.parseMorphFrame,
		Parser.parseCalibFrame,
		Parser.parseMicFrame,
		Parser.parseIKRig
	];
	static typeTable = [
		undefined,
		"rotations",
		"translations",
		"morph",
		"calib",
		"mic",
		"ikrig"
	];
	static parse(buf){
		const id = new Uint8Array(buf)[0];
		return [Parser.typeTable[id], Parser.parseTable[id].bind(Parser)(buf.slice(1))];
	}

	static DeserializeQ(bits){
		const id = bits.consume(2, false);
		const x = bits.consume(14)/10000;
		const y = bits.consume(14)/10000;
		const z = bits.consume(14)/10000;
		const r = Math.sqrt(Math.abs(1.0 - (Math.pow(x, 2) + Math.pow(y, 2) + Math.pow(z, 2))));
		switch(id){
			case 0:
				return new THREE.Quaternion(x, y, z, r);
			case 1:
				return new THREE.Quaternion(r, y, z, x);
			case 2:
				return new THREE.Quaternion(y, r, z, x);
			case 3:
				return new THREE.Quaternion(y, z, r, x);
			default:
				return new THREE.Quaternion();
		}
	}
	static parseIKRig(buf)
	{
		var view = new DataView(buf.slice(0,12));
		var num = view.getFloat32(0,true);
		var num2 = view.getFloat32(4,true);
		var num3 = view.getFloat32(8,true);
		num,num2,num3;
		let floats = new Float32Array(buf.slice(0,12));
		ikRig.root_pos = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		const bits = new BitsConsumer(buf.slice(12,40));
		const rotations = [];
		for(let i=0; i<5; i++){
			rotations.push(Parser.DeserializeQ(bits));
		}
		ikRig.root_rot = new THREE.Quaternion(rotations[0].x,-rotations[0].y,-rotations[0].z,rotations[0].w);
		ikRig.l_hand_rot = new THREE.Quaternion(rotations[1].x,-rotations[1].y,-rotations[1].z,rotations[1].w);
		ikRig.r_hand_rot = new THREE.Quaternion(rotations[2].x,-rotations[2].y,-rotations[2].z,rotations[2].w);
		ikRig.l_foot_rot = new THREE.Quaternion(rotations[3].x,-rotations[3].y,-rotations[3].z,rotations[3].w);
		ikRig.r_foot_rot = new THREE.Quaternion(rotations[4].x,-rotations[4].y,-rotations[4].z,rotations[4].w);
		let offset = 40;
		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.l_arm_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.l_arm_pole = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.l_arm_len = floats[0];

		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.r_arm_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.r_arm_pole = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.r_arm_len = floats[0];


		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.l_leg_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.l_leg_pole = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.l_leg_len = floats[0];

		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.r_leg_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.r_leg_pole = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.r_leg_len = floats[0];

		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.spine_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		ikRig.spine_direction = ikRig.spine_direction.multiplyScalar(2);
		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.spine_pole = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.spine_len = floats[0];
		ikRig.spine_len = ikRig.spine_len * 2;

		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.neck_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.neck_pole = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.neck_len = floats[0];

		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.l_thumb_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.l_thumb_len = floats[0];

		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.r_thumb_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.r_thumb_len = floats[0];

		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.l_index_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.l_index_len = floats[0];

		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.r_index_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.r_index_len = floats[0];

		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.l_middle_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.l_middle_len = floats[0];

		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.r_middle_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.r_middle_len = floats[0];
		
		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.l_ring_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.l_ring_len = floats[0];

		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.r_ring_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.r_ring_len = floats[0];

		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.l_pinky_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.l_pinky_len = floats[0];

		floats = [...(new Int16Array(buf.slice(offset, offset+6)))].map(e=>e/32767.0);
		offset+=6;
		ikRig.r_pinky_direction = new THREE.Vector3(-floats[0],floats[1],floats[2]);
		floats = [...(new Int16Array(buf.slice(offset, offset+2)))].map(e=>e/32767.0);
		offset+=2;
		ikRig.r_pinky_len = floats[0];

		floats = [...(new Uint16Array(buf.slice(offset, offset+2)))].map(e=>e/65535.0);
		offset+=2;
		ikRig.height = floats[0];
		return ikRig;
	}

	static parseRotationFrame(buf)
	{
		const model_id = new BigUint64Array(buf.slice(0, 8))[0];/* eslint-disable-line */
		const bits = new BitsConsumer(buf.slice(8));
		const num_joints = model_id==98969896 ? 22 : model_id;
		const rotations = [];
		for(let i=0; i<num_joints; i++){
			rotations.push(Parser.DeserializeQ(bits));
			if(i==3 || i==6)
				rotations[i].multiply(new THREE.Quaternion().setFromEuler(new THREE.Euler(-25*0.0174533,0,0)));
		}
		return rotations;
	}

	static parseTranslationFrame(buf)
	{
		// const model_id = new BigUint64Array(buf.slice(0, 8))[0];
		// const num_joints = model_id==98969896 ? 22 : model_id;
		const root = new THREE.Vector3(...(new Float32Array(buf.slice(8, 20))));
		const lens = [...(new Uint16Array(buf.slice(20)))].map(e=>e/65535.0);
		return [root, lens];
	}

	static parseMorphFrame(buf)
	{
		return [...new Uint8Array(buf)].map((e)=>{return e/255.0;});
	}

	static parseCalibFrame(buf)
	{
		const model_id = new BigUint64Array(buf.slice(0, 8))[0];/* eslint-disable-line */
		if(model_id==98969896){
			const arr = new Float32Array(buf.slice(8));
			const [h, w] = [arr[0]*100, arr[1]*100];
			return [h, w];
		}
	}
	
	static parseMicFrame(buf)
	{
		return new Uint8Array(buf[0]);
	}
}